import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ISettingsTable } from 'src/app/@amiga-pyme/interfaces/table.interface';
import { SaleNoteDocumentDetailService } from '../../sales-notes-detail.service';

@Component({
  selector: 'ami-detail-sale-note-dialog',
  templateUrl: './detail-dialog.component.html'
})
export class DetailSaleNoteDialogComponent {
  visible = true;
  @Input() idDocument: number;
  @Output() onHideData = new EventEmitter<boolean>();

  detailsResponseFlattenned: any[];
  tableDetailSettings: ISettingsTable;
  constructor(private saleNoteService: SaleNoteDocumentDetailService) {}

  async ngOnInit() {
    // console.log('Initializing detail dialog');
    this.tableDetailSettings = {
      title: 'Detalle de documento',
      columns: [
        { header: 'Descripción', field: 'description' },
        { header: 'Formato', field: 'format' },
        { header: 'Cantidad.', field: 'quantity' },
        { header: 'Pr.Unit', field: 'priceUnit' },
        { header: 'Precio', field: 'price' }
      ]
    };

    const { data, status } = await this.saleNoteService.getById(
      this.idDocument
    );

    if (status === 200) {
      this.flatDetailsForVoucher(data as any[]);
      this.visible = true;
    }
  }

  onHideDataDialog() {
    this.visible = false;
    this.idDocument = undefined;
    this.onHideData.emit();
  }

  flatDetailsForVoucher(saleDetails: any[]) {
    const flattenedDetails = [];
    for (const saleDetail of saleDetails) {
      Object.entries(saleDetail.formats).map(([formatName, formatDetails]) => {
        const newFlattenedDetail = {
          description: saleDetail.description,
          format: formatName,
          quantity: formatDetails['cantidad'],
          priceUnit: formatDetails['precio'],
          price: formatDetails['cantidad'] * formatDetails['precio']
        };
        flattenedDetails.push(newFlattenedDetail);
      });
    }
    this.detailsResponseFlattenned = [...flattenedDetails];
  }
}
